<template>
  <v-footer
    absolute
    color="transparent"
    class="pa-0"
    :class="[
      exibeCentral && isDesktop ? 'login-rodape' : '',
      exibeCentral && isDesktopLarge ? 'login-rodape-lg' : '',
    ]"
  >
    <div class="mx-auto">
      <v-container
        fluid
        class="pa-0"
      >
        <v-row>
          <v-col
            :class="$vuetify.breakpoint.mdAndUp && !exibeCentral ? 'ml-md-2' : ''"
            cols="12"
            class="pt-3 pb-4 px-0"
          >
            <v-row justify="center">
              <v-btn
                :class="$vuetify.breakpoint.mdAndUp && !exibeCentral ? 'ml-md-12' : ''"
                text
                target="_blank"
                class="text-none grey--text text--darken-2 px-1"
                data-cy="link_termo"
                :href="urlTermos"
              >
                Termos e Políticas
              </v-btn>

              <v-divider
                v-if="exibeCentral"
                vertical
                class="mx-1 my-auto grey"
                style="height: 15px"
              />

              <v-btn
                v-if="exibeCentral"
                text
                target="_blank"
                class="text-none grey--text text--darken-2 px-1"
                data-cy="link_central_de_ajuda"
                :href="urlCentralAjuda"
              >
                Central de ajuda
              </v-btn>
            </v-row>
          </v-col>
        </v-row>
      </v-container>
    </div>
  </v-footer>
</template>

<script>
import isCenterpagEnvironment from '@/utils/environment';

export default {
  name: 'Rodape',

  props: {
    exibeCentral: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      urlCentralAjuda: isCenterpagEnvironment()
        ? 'https://www.centerpag.com.br/#we_have_the_answer'
        : 'https://ajuda.monetizze.com.br/hc/pt-br/categories/360002019152-Compras-atrav%C3%A9s-da-Monetizze',
      urlTermos: isCenterpagEnvironment()
        ? 'https://www.centerpag.com.br/terms-of-use/index.html'
        : 'https://monetizze.com.br/termos#buying',
    };
  },

  computed: {
    isDesktop() {
      return this.$vuetify.breakpoint.mdAndUp;
    },

    isDesktopLarge() {
      return this.$vuetify.breakpoint.lgAndUp;
    },
  },
};
</script>

<style scoped lang="scss">
.login-rodape {
  right: auto !important;
  left: 41vw !important;
  margin-left: 5vw;
  max-width: 585px;
  width: calc(54vw - 16px);
}
.login-rodape-lg {
  margin-left: 107px;
  width: 59vw;
}
</style>
